import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";

// Only HTTP images break on an HTTPS page (mixed content), so only those are routed
// through the backend proxy. HTTPS image URLs (the common case) and relative paths
// load directly — so admins can paste an image URL from any HTTPS source freely.
export const proxiedImageUrl = (url) => {
    if (!url) return "";
    if (/^http:\/\//i.test(url)) {
        return `${BACKEND_API_URL}/image-proxy?url=${encodeURIComponent(url)}`;
    }
    return url;
};

export const fetchCarouselBooks = async ({ onSuccess = null, onError = null } = {}) => {
    try {
        const response = await fetch(`${BACKEND_API_URL}/carousel-book`, { method: "GET" });
        const data = await handleApiResponse(response, "fetchCarouselBooks");
        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const createCarouselBook = async ({ auth, payload, onSuccess = null, onError = null }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/carousel-book`,
            { method: "POST", body: JSON.stringify(payload) },
            auth
        );
        const data = await handleApiResponse(response, "createCarouselBook");
        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const updateCarouselBook = async ({ auth, carouselBookId, payload, onSuccess = null, onError = null }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/carousel-book/${carouselBookId}`,
            { method: "PUT", body: JSON.stringify(payload) },
            auth
        );
        const data = await handleApiResponse(response, "updateCarouselBook");
        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const deleteCarouselBook = async ({ auth, carouselBookId, onSuccess = null, onError = null }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/carousel-book/${carouselBookId}`,
            { method: "DELETE" },
            auth
        );
        const data = await handleApiResponse(response, "deleteCarouselBook");
        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};
